//Packages
import React, { useState } from 'react';
import { Typography, Button, Box, useMediaQuery } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid'

// Local
import formatName from '../utilities/formatName';
import formatPhoneNumber from '../utilities/formatPhoneNumber';

const RetakeUsersTile = ({ rows, onHeaderClick, onRowClick=null }) => {
    const isMobile = useMediaQuery("(max-width:600px)");
    const paginationModel = { page: 0, pageSize: 10 };

    const [selectedIds, setSelectedIds] = useState([]);

    const gridRows = rows;

    const gridColumns = [
        { flex: 0.5, headerName: 'User ID', field: 'id'},
        { flex: 1, headerName: 'First Name', field: 'first_name', renderCell: (params) => <span>{formatName(params.row.first_name)}</span> },
        { flex: 1, headerName: 'Last Name', field: 'last_name', renderCell: (params) => <span>{formatName(params.row.last_name)}</span> },
        { flex: 1, headerName: 'Phone Number', field: 'phone_number', renderCell: (params) => <span>{formatPhoneNumber(params.row.phone_number)}</span> },
        { flex: 1, headerName: 'Email', field: 'email' },
        { flex: 1.5, headerName: 'Retake', field:'retake'},
    ];

    const outerBoxStyle = {
        display: 'flex',
        flexDirection: 'column',
        boxShadow: 3,
        borderRadius: 4,
        width:'100%',
        height:'auto',
    };

    const headerStyle = {
        bgcolor: '#1483FA',
        color:'#FFFFFF',
        px:2,
        pt:2,
        borderTopRightRadius:16,
        borderTopLeftRadius:16,
        pb:1,
        borderBottomLeftRadius: rows.length === 0 ? 16 : 0,
        borderBottomRightRadius: rows.length === 0 ? 16 : 0,
        cursor:'pointer',
        '&:hover': {
            bgcolor: '#0f6bcc'
        },
    };

    const headerTextStyle = { fontWeight:650, textShadow: '2px 2px 4px rgba(0, 0, 0, 0.25)' };
    const gridStyle = { m:1, borderRadius:4, cursor:'pointer' };

    const handleCopyEmails = () => {
        const selectedRows = gridRows.filter((row) => selectedIds.includes(row.id));
        const emails = selectedRows.map((row) => row.email).join('; ');
        navigator.clipboard.writeText(emails);
    };

    return (
        <Box sx={outerBoxStyle}>
            <Box sx={headerStyle} onClick={onHeaderClick}>
                <Typography variant='h4' sx={headerTextStyle}>Retake Users</Typography>
            </Box>
            {rows.length > 0 && (
                <>
                    <DataGrid
                        sx={gridStyle}
                        rows={gridRows}
                        columns={gridColumns}
                        checkboxSelection
                        initialState={{ 
                            pagination: { paginationModel },
                            columns: {
                                columnVisibilityModel: { id: true }
                            }
                        }}
                        disableRowSelectionOnClick
                        pageSizeOptions={[10, 30, 50, 100]}
                        onRowDoubleClick={(params) => {
                            onRowClick(params.row.id)
                            window.scrollTo(0,0);
                        }}
                        onRowSelectionModelChange={(newSelection) => {
                            setSelectedIds(newSelection);
                        }}
                    />
                    {selectedIds.length > 0 && (
                        <Button 
                            variant="contained" 
                            sx={{ m: 2, alignSelf: 'flex-start' }}
                            onClick={handleCopyEmails}
                        >
                            Copy Emails
                        </Button>
                    )}
                </>
            )}
        </Box>
    )
}

export default RetakeUsersTile;
